import { render, staticRenderFns } from "./workOrderEdit.vue?vue&type=template&id=c38b70b4"
import script from "./workOrderEdit.vue?vue&type=script&lang=js"
export * from "./workOrderEdit.vue?vue&type=script&lang=js"
import style0 from "./workOrderEdit.vue?vue&type=style&index=0&id=c38b70b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports